import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterKlausenLeopoldsdorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-klausen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-klausen-heading">WETTER</h1>
        </div>

        {/* Ortsname korrigiert: alles lowercase, keine Großbuchstaben → wichtig für CSV-Ladepfad */}
        <Wetter ort="klausen-leopoldsdorf" />
      </div>
    </div>
  );
}

export default WetterKlausenLeopoldsdorf;
